import React from 'react';
import { Tag } from '../../../common/tags/tagTypes';
import TagElement from './TagElement';

import './TagElementPillsContainer.scss';

type TagElementPillsContainerProps = {
    tags: Tag[];
    size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
};

const TagElementPillsContainer: React.FC<TagElementPillsContainerProps> = ({ tags, size }) => {
    return (
        <div className="TagElementPillsContainer">
            {tags.map(({ _id, name, color }) => (
                <div key={_id} className="mr-1 max-w-full">
                    <TagElement name={name} color={color} size={size} />
                </div>
            ))}
        </div>
    );
};

export default TagElementPillsContainer;
